import axios from "axios";
import Config from "../../Config";

class SubscriptionRequest {
  static baseUrl = `${Config.backendDomain}`;
  
  static NETWORK_CODES = {
    'MTN Mobile Money': 'MTN',
    'AirtelTigo Money': 'ATL',
    'Telecel Cash': 'TGO',
  };

  async getSubscriptionHistory() {
    const response = await axios.get(`${SubscriptionRequest.baseUrl}vendor/all/transactions`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('dealboxx_token')}`
      }
    });
    return response.data;
  }

  async initiateSubscription(phoneNumber, network, plan) {
    try {
      //* Format phone number to required format (233...)
      const formattedPhone = this.formatPhoneNumber(phoneNumber);
      
      //* Get network code
      const networkCode = SubscriptionRequest.NETWORK_CODES[network] || network;

      const payload = {
        phone_number: formattedPhone,
        network: networkCode,
        subscription_plan: plan.toLowerCase(),
      };

      const response = await axios.post(
        `${SubscriptionRequest.baseUrl}vendor/subscription/payment`,
        payload,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('dealboxx_token')}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;

    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.reason || "An error occurred while processing payment",
        data: null,
        error: error.response?.data || error.message
      };
    }
  }

  async verifySubscription(transactionId) {
    const response = await axios.get(`${SubscriptionRequest.baseUrl}vendor/transactions/${transactionId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('dealboxx_token')}`
      }
    });
    return response.data;
  }

  async fetchUserCurrentSubscription(){
    const response = await axios.get(`${SubscriptionRequest.baseUrl}vendor/current/subscriptions`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('dealboxx_token')}`
      }
    });
    return response.data;
  }

  async fetchUserSubscriptionHistory(){
    const response = await axios.get(`${SubscriptionRequest.baseUrl}vendor/all/transactions`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('dealboxx_token')}`
      }
    });
    return response.data;
  }

  formatPhoneNumber(phone) {
    let cleaned = phone.toString().replace(/\D/g, '');
    cleaned = cleaned.replace(/^0+/, '');    
    if (!cleaned.startsWith('233')) {
      cleaned = '233' + cleaned;
    }
    
    return parseInt(cleaned);
  }
}

const instance = new SubscriptionRequest();
Object.freeze(instance);
export default instance;